import DOMPurify from "dompurify";

interface TextBoxHtmlProps {
	className?: string;
	html: string;
}

/**
 * Renders caller-supplied HTML. The content reaching this component is authored by
 * other parties -- supplier/procurer clarifications, bidder submissions, company
 * profile text -- so it is sanitised before rendering. DOMPurify's default profile
 * keeps the list markup this component styles for (`ol`/`ul`) while stripping
 * scripts, event handlers and other active content.
 */
export const TextBoxHTML: React.FC<TextBoxHtmlProps> = ({
	className,
	html,
}) => {
	return (
		html && (
			<p
				className={`[&>ol]:ml-5 [&>ol]:!list-decimal [&>ul]:ml-5 [&>ul]:!list-disc ${className}`}
				dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
			/>
		)
	);
};

export default TextBoxHTML;
